// extracted by mini-css-extract-plugin
export var addToCartButton = "_t2-b";
export var arrowButtonContainer = "_t2-9";
export var arrowButtonIcon = "_t2-a";
export var carouselArrowButton = "_t2-6";
export var carouselElementContainer = "_t2-1";
export var galleryThumbnail = "_t2-d";
export var galleryThumbnailImage = "_t2-e";
export var left = "_t2-7";
export var productDisplayCarouselContainer = "_t2-0";
export var productTileContainer = "_t2-2";
export var productTileImage = "_t2-4";
export var productTileImageContainer = "_t2-3";
export var productTileTitle = "_t2-5";
export var right = "_t2-8";
export var sliderOverflow = "_t2-c";